import type { TaxonomyIndustry, TaxonomySegment } from '@icetus/contracts';

/**
 * 行业选择器的搜索。
 *
 * 一级有 38 个、二级 228 个之后，「滚着找」不成立了。搜索要回答的是
 * 「客户脑子里的那个词」—— 他打的可能是一级名（照明）、英文名（Lighting），
 * 也可能是具体商品（角磨机、潜水镜）。所以全部都算命中。
 *
 * 单独放一个文件是为了能被单测：命中规则错一点，客户就会在列表里
 * 看不到自己的行业，而这在页面上看起来只是「没找到」。
 */

function hit(text: string, q: string): boolean {
  // q 也统一小写：调用方传的是已经归一化的词，但这个函数本身不该依赖这一点
  return text.toLowerCase().includes(q.toLowerCase());
}

/** 这个词命中这个二级吗 */
export function segmentHit(segment: TaxonomySegment, q: string): boolean {
  if (hit(segment.label, q) || hit(segment.en, q)) return true;
  if (segment.aliases?.some((alias) => hit(alias, q))) return true;
  return segment.seeds.some((seed) => hit(seed.zh, q) || hit(seed.en, q));
}

/** 这个词命中这个一级吗 */
export function industryHit(industry: TaxonomyIndustry, q: string): boolean {
  if (hit(industry.label, q) || hit(industry.en, q)) return true;
  return industry.segments.some((segment) => segmentHit(segment, q));
}

/**
 * 命中的二级。
 *
 * 恰好命中一个时，点击一级就把它一并选上 —— 客户搜「角磨机」，
 * 意思就是「我这条线做角磨机」，再让他选一次产品线是多余的。
 * 命中两个以上则不替他决定。
 */
export function matchedSegments(industry: TaxonomyIndustry, q: string): TaxonomySegment[] {
  return q ? industry.segments.filter((segment) => segmentHit(segment, q)) : [];
}
